import type { ParamMatcher } from '@sveltejs/kit';

export const pages = [
	'summary',
	'opens',
	'clicks',
	'unsubscribed',
	'spam',
	'delayed',
	'undeliverable',
] as const;

export const match: ParamMatcher = (param) => {
	// @ts-ignore
	return pages.includes(param);
};
